// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__2yX6e","loader":"ContentLoader_loader__1nyho","disabled":"ContentLoader_disabled__3ZacC"};